import React, { useState } from "react";
import { StyledText, Title } from "components/common/info/styled";
import { ErrorBoundaryPage } from "components/common/error";
import { AuthBranding } from "components/common/branding";
import axios from "axios";
import { AuthContainer, FormContainer } from "components/common/container";
import { VerifyEmail } from "user/VerifyEmail";
import styled from "styled-components";
import { EmailVerificationType } from "utils/enums/enum-emailVerificationType";

const StyledFormContainer = styled(FormContainer)`
  border-radius: 12px;
`;

const StyledTitle = styled(Title)`
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  color: ${(props) => props.theme.colors.primary};
`;

export const ResetPasswordEmailVerify: React.FC = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string>("");
  const [success, setSuccess] = useState<boolean>(false);
  const displayMessage =
    "If an account exists for this email address, you'll receive a password reset email shortly.";
  const apiBaseUrl = process.env.REACT_APP_URL_API;

  const handleSubmit = async () => {
    const payload = {
      email: email,
      verificationType: EmailVerificationType.PasswordReset,
    };

    await axios
      .post(`${apiBaseUrl}/v1/createemailverify`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        setSuccess(true);
      })
      .catch(() => {
        setSuccess(true);
      });
  };

  return (
    <ErrorBoundaryPage>
      <AuthBranding />
      <AuthContainer>
        <StyledFormContainer>
          <StyledTitle>Create/Reset Password</StyledTitle>
          {success ? (
            <StyledText>{displayMessage}</StyledText>
          ) : (
            <VerifyEmail
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              onClick={handleSubmit}
              error={error}
              success={success}
            />
          )}
          <StyledText></StyledText>
          <StyledText>
            <a href="/">Back</a>
          </StyledText>
        </StyledFormContainer>
      </AuthContainer>
    </ErrorBoundaryPage>
  );
};
